import React, { ReactNode, useEffect, useMemo, useState } from 'react';

import { lookupAddress } from '../services/iplocator';

interface Props {
  children: ReactNode;
}

const IpLookupContext = React.createContext({
  ipLocation: 'en',
});

export const IpLookupProvider = ({ children }: Props) => {
  const [ipLocation, setIpLocation] = useState('en');

  useEffect(() => {
    lookupAddress().then(({ countryCode }) => {
      setIpLocation(countryCode);
    });
  }, []);

  const ipProviderValue = useMemo(() => ({ ipLocation }), [ipLocation]);

  return <IpLookupContext.Provider value={ipProviderValue}>{children}</IpLookupContext.Provider>;
};

export const useIpData = () => React.useContext(IpLookupContext);
